export default __webpack_public_path__ + "static/segmentimage-87488409fe04e5f6425104db34fe5db2.png";